import { alias } from '@ember/object/computed';

import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import moment from 'moment';

export default class AssetFormatRelationModel extends Model {
  @attr('string') assetTypeSelector;
  @attr('string') audioBitrate;
  @attr('string') audioChannels;
  @attr('string') audioCodec;
  @attr('string') audioFrequenz;
  @attr('boolean') convertRunning;
  @attr('string') convertMessage;
  @attr('string') convertCommandLog;
  @attr('string') cropDimension;
  @attr('string') cropXy;
  @attr('string') duration;
  @attr dateEnd;
  @attr dateStart;
  @attr('string') fileSize;
  @attr('string') flagManualRedo;
  @attr('string') flagRedo;
  @attr('number') height;
  @attr('boolean') isManualUpload;
  @attr('string') mimeType;
  @attr('number', { defaultValue: 0 }) priority;
  @attr('string') sourceFormatId;
  @attr('string') tmpAssetName;
  @attr('string') videoBitrate;
  @attr('string') videoCodec;
  @attr('number') width;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsModified;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('asset-format', { async: true, inverse: null }) assetFormat;
  @belongsTo('asset', { async: true, inverse: 'assetFormatRelations' }) asset;

  // Getter, setter and computed properties
  @alias('assetFormat.isDownloadFormat') isDownloadFormat;
  @alias('assetFormat.label') displayHeadline;

  get displayLabel() {
    return `${this.assetFormat.get('id')}: ${this.assetFormat.get('label')}`;
  }

  get durationString() {
    if (!this.duration) {
      return null;
    }

    let duration = moment.duration(this.duration, 'seconds').asMilliseconds();

    return moment.utc(duration).format('HH:mm:ss');
  }

  get isSourceFormat() {
    return this.belongsTo('assetFormat').id() === '195';
  }

  get mime() {
    let mimeType = this.mimeType;
    let mime = mimeType?.split('/').pop();
    let isTvSuitable = ['mxf', 'octet-stream'].includes(mime);

    if (!mimeType || mimeType === 'no file') {
      return '';
    }

    return `${mime}${isTvSuitable ? ' (TV geeignet)' : ''}`;
  }

  get hasError() {
    return this.status === 'error';
  }

  get isSuccess() {
    let convertMessageOk = ['OK', 'Format file generated!', null].includes(
      this.convertMessage,
    );

    return convertMessageOk && this.dateStart && this.dateEnd;
  }

  get status() {
    if (this.isSourceFormat || this.isSuccess) {
      return 'success';
    } else if (this.convertRunning) {
      return 'running';
    } else if (!this.dateEnd) {
      return 'waiting';
    } else {
      return 'error';
    }
  }

  get resolution() {
    if (!this.width || !this.height) {
      return null;
    }

    return `${this.width}x${this.height}`;
  }
}
